export default __webpack_public_path__ + "static/media/normal-star.e864fe5f.svg";